import {Pagination, PaginationItem, PaginationRenderItemParams, Stack} from '@mui/material';
import React from 'react';
import {observer} from 'mobx-react-lite';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {TablePaginationProps} from '../../../../entity/props/widget/table-pagination-props';

import '../../../../assets/css/widget/table-pagination.css';

const TablePagination = (props: TablePaginationProps): JSX.Element => {

  return (
    <Stack spacing={2} className={'pagination-container'}>
      <Pagination
        count={props.totalPages}
        siblingCount={4}
        boundaryCount={1}
        defaultPage={1}
        page={props.currentPage}
        onChange={props.onChange}
        renderItem={(item: PaginationRenderItemParams): JSX.Element =>
          <PaginationItem
            component='div'
            slots={{
              previous: (): JSX.Element => (
                <Stack direction='row' alignItems='center' spacing={1} id={'btn-pagination-prev'} className={'previous-btn'}>
                  <ArrowBackIcon />
                  <span>Prev</span>
                </Stack>
              ),
              next: (): JSX.Element => (
                <Stack direction='row' alignItems='center' spacing={1} id={'btn-pagination-next'} className={'next-btn'}>
                  <span>Next</span>
                  <ArrowForwardIcon />
                </Stack>
              )
            }}
            {...item}/>
        }/>
    </Stack>
  );
}

export default observer(TablePagination);
